<template>
  <div>
    <!-- 删除弹出框 -->
    <delete-box :title=" $t('lang.Button.delete')" ref="delete" @removelist="delParam($event,index)"></delete-box>
    <el-button 
      type="primary" 
      size="mini" 
      class="elinput" 
      @click="centerDialogVisible=true"
      v-if="Permission.indexOf(169)!=-1">
      {{$t('lang.Button.Add')}}
    </el-button>
    <!-- <p class="tabletitle"></p> -->
    <el-table
      :data="data"
      height="650"
      size="mini"
      id="out-table"
      @sort-change="sortChange"
      row-key="paramId"
      :header-cell-style="{background:'#e4f1ff'}">
      <el-table-column type="selection" min-width="40" :selectable="checkboxInit"></el-table-column>
      <el-table-column :label="$t('lang.parameter.name')" align="center" sortable="custom">
        <template slot-scope="scope">
          <el-input
            size="mini"
            v-if="scope.$index==0"
            :placeholder="$t('lang.parameter.name')"
            clearable
            v-model="seek.Englishname">
          </el-input>
          <span class="spanov" v-show="scope.$index!==0">{{scope.row.paramName}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.parameter.description')"  sortable="custom">
        <template slot-scope="scope">
          <el-input
            size="mini"
            v-if="scope.$index==0"
            :placeholder="$t('lang.parameter.description')"
            v-model="seek.Chinesename"
            clearable>
          </el-input>
          <span
            class="spanov"
            v-show="scope.$index!==0&&!scope.row.edac">
            {{scope.row.paramZhongwen}}
          </span>
          <el-input
            size="mini"
            clearable
            v-if="scope.$index!==0&&scope.row.edac"
            v-model="scope.row.paramZhongwen">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.parameter.value')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            size="mini"
            clearable
            v-if="scope.$index==0"
            :placeholder="$t('lang.parameter.value')"
            v-model="seek.paramValue"
          ></el-input>
          <span class="spanov" v-show="scope.$index!==0&&!scope.row.edac">{{scope.row.paramValue}}</span>
          <el-input v-model="scope.row.paramValue" size="mini" v-show="scope.$index!==0&&scope.row.edac"/>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.parameter.time')" sortable="custom">
        <template slot-scope="scope">
          <el-input
            size="mini"
            v-if="scope.$index==0"
            :placeholder="$t('lang.parameter.time')"
            clearable
            v-model="seek.paramUpdate"
          ></el-input>
          <span class="spanov" v-show="scope.$index!==0">{{scope.row.paramUpdate}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Button.operation')" align="center">
        <template slot-scope="scope">
          <el-button
            type="success"
            icon="el-icon-check"
            circle
            v-if="scope.$index!==0&&scope.row.edac&&Permission.indexOf(170)!=-1"
            @click="setshowedac(scope.$index)"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            v-if="scope.$index!==0&&!scope.row.edac&&Permission.indexOf(170)!=-1"
            @click="showedac(scope.$index)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            v-if="scope.$index!==0&&Permission.indexOf(171)!=-1"
            @click="$refs.delete.opendelete(scope.$index)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加参数弹出框 -->
    <el-dialog :title="$t('lang.Button.Add')" :visible.sync="centerDialogVisible" width="30%" center>
      <div class="dialog_center">
        <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign">
          <el-form-item :label="`${$t('lang.parameter.name')}：`">
            <el-input v-model="formLabelAlign.Englishname" size="mini" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.parameter.description')}：`">
            <el-input v-model="formLabelAlign.Chinesename" size="mini" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.parameter.value')}：`">
            <el-input v-model="TypeValue" size="mini" style="width:100%"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{$t('lang.Button.cancel')}}</el-button>
        <el-button type="primary" @click="addParam">{{$t('lang.Button.submit')}}</el-button>
      </span>
    </el-dialog>
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
  </div>
</template>
<script>
import {
  listParam,
  queryKeyword,
  addParam,
  delParam,
  updateParam
} from "../../../api/parametermanagement"
import pagination from "@/components/pagination"
import DeleteBox from "@/components/DeleteBox"
import { PublicComponent } from "../../../mixins/common"
import { getPermission } from "../../../cookie/cookie";
export default {
  mixins: [PublicComponent],
  data() {
    return {
      //权限数组
      Permission: [],
      data: [],
      centerDialogVisible: false,
      labelPosition: "right",
      //添加绑定值
      formLabelAlign: {
        Chinesename: "",
        Englishname: ""
      },
      //搜索绑定值
      seek: {
        Chinesename: "",
        Englishname: "",
        paramUpdate: "",
        paramValue:""
      },
      sort: {
        Chinesename: null,
        Englishname: null,
        paramUpdate: null,
        paramValue:null
      },
      TypeList:[
        {label:1,value:1},
        {lebel:2,value:2},
        {label:3,value:3}
      ],
      TypeValue:1
    };
  },
  components: {
    pagination,
    DeleteBox
  },
  methods: {
    //修改参数名
    setshowedac(index) {
      updateParam(
        this.data[index].paramId,
        this.data[index].paramZhongwen,
        this.data[index].paramName,
        this.data[index].paramValue
      ).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t('lang.Button.successEdit'),
            type: "success"
          });
          this.queryKeyword();
        } else {
          this.$message({
            showClose: true,
            message:  this.$t('lang.Button.failEdit'),
            type: "warning"
          });
          this.queryKeyword();
        }
      });
      this.data[index].edac = false;
    },
    //显示修改输入框
    showedac(index) {
      this.data[index].edac = true;
    },
    //添加参数配置
    addParam() {
      addParam(
        this.formLabelAlign.Chinesename,
        this.formLabelAlign.Englishname,
        this.TypeValue
      ).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t('lang.Button.successAdd'),
            type: "success"
          })
          this.queryKeyword();
        } else if (res.data.code == 32) {
          this.$message({
            showClose: true,
            message: this.$t('lang.parameter.chineseName'),
            type: "warning"
          })
          this.queryKeyword()
        } else if (res.data.code == 33) {
          this.$message({
            showClose: true,
            message: this.$t('lang.parameter.englishName'),
            type: "warning"
          })
          this.queryKeyword()
        } else {
          this.$message({
            showClose: true,
            message: this.$t('lang.Button.failAdd'),
            type: "warning"
          });
          this.queryKeyword();
        }
      });
      this.centerDialogVisible = false;
    },
    //删除参数
    delParam(index) {
      delParam(this.data[index].paramId).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t('lang.Button.successDelete'),
            type: "success"
          });
          this.queryKeyword();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('lang.Button.failDelete'),
            type: "warning"
          });
          this.queryKeyword();
        }
      });
    },
    //搜索参数
    queryKeyword() {
      console.log('seek', this.seek);
      
      queryKeyword(
        [this.seek.Chinesename, this.seek.Englishname,this.seek.paramValue,this.seek.paramUpdate],
        this.offset,
        this.limit,
        this.sort
      ).then(res => {
        this.data = res.data.data.list;
        //给列表数据添加输入框修改参数
        this.data.forEach((val, index, arr) => {
          this.$set(val, "edac", false);
        });
        this.data.unshift({});
        this.total = res.data.data.total;
      });
    },
    //表格排序
    sortChange({ column, prop, order }) {
      // 每次点击清空一次排序的赋值
      this.sort = {
        Chinesename: null,
        Englishname: null,
        paramUpdate: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      console.log('lable', label);
      
      if (label == this.$t('lang.parameter.name')){
        this.sort.Chinesename = sortlist;
      } else if (label == this.$t('lang.parameter.description')) {
        this.sort.Englishname = sortlist;
      } else if (label == this.$t('lang.parameter.time')) {
        this.sort.paramUpdate = sortlist;
      } else if (label == this.$t('lang.parameter.value')) {
        this.sort.paramValue = sortlist
      }
    }
  },
  mounted() {
    //获取权限列表
    this.Permission = getPermission();
    //获取参数列表
    listParam().then(res => {
      console.log(res.data.data)
      this.data = res.data.data.list
      //给列表数据添加输入框修改参数
      this.data.forEach((val, index, arr) => {
        this.$set(val, "edac", false)
      })
      this.data.unshift({})
      this.total = res.data.data.total
    })
  }
};
</script>
<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
  display: block;
  line-height: 41px;
}
.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}
.dialog_center{
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
